import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=33968a01&scoped=true&"
import script from "./swiper.vue?vue&type=script&lang=js&"
export * from "./swiper.vue?vue&type=script&lang=js&"
import style0 from "./swiper.vue?vue&type=style&index=0&id=33968a01&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-f71fe88aef/0/cache/vue-loader-npm-15.10.1-3a0b6c19d2-753a6b6da2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33968a01",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/home/runner/work/makestar-web-service/makestar-web-service/components/common/Image.vue').default,CommonSkeleTon: require('/home/runner/work/makestar-web-service/makestar-web-service/components/common/skeleTon.vue').default})
